// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style-module--wrapper--1i9fZ","item":"style-module--item--1wHAb"};